import { render, staticRenderFns } from "./DocumentPreparation.vue?vue&type=template&id=6f0a272e&scoped=true&"
import script from "./DocumentPreparation.vue?vue&type=script&lang=ts&"
export * from "./DocumentPreparation.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentPreparation.vue?vue&type=style&index=0&id=6f0a272e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0a272e",
  null
  
)

export default component.exports